import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";

export default function Register() {
  const { register: doRegister } = useAuth();
  const nav = useNavigate();
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [role, setRole] = useState("fan"); // Default: Fan
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password !== confirm) return setErr("Passwörter stimmen nicht überein.");
    setLoading(true);
    try {
      await doRegister({ email, password, displayName, role });
      nav("/");
    } catch (e2) {
      setErr("Registrierung fehlgeschlagen. Bitte versuche es erneut.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0e0b0c] flex items-center justify-center px-4 pb-20" data-testid="register-screen">
      <Card className="w-full max-w-sm bg-[#1a0d11] border-white/10 text-rose-50">
        <CardContent className="pt-6">
          <h1 className="text-2xl font-bold mb-6" data-testid="register-title">Konto erstellen</h1>
          {err && (<div className="text-red-300 text-sm mb-3" data-testid="register-error">{err}</div>)}
          <form onSubmit={submit} className="space-y-4" data-testid="register-form">
            <div>
              <label className="text-sm">Anzeigename</label>
              <Input data-testid="register-display" value={displayName} onChange={(e)=>setDisplayName(e.target.value)} className="bg-[#2a1419] border-white/10 text-rose-50" />
            </div>
            <div>
              <label className="text-sm">E-Mail</label>
              <Input data-testid="register-email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required className="bg-[#2a1419] border-white/10 text-rose-50" />
            </div>
            <div>
              <label className="text-sm">Passwort</label>
              <Input data-testid="register-password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required className="bg-[#2a1419] border-white/10 text-rose-50" />
            </div>
            <div>
              <label className="text-sm">Passwort bestätigen</label>
              <Input data-testid="register-confirm" type="password" value={confirm} onChange={(e)=>setConfirm(e.target.value)} required className="bg-[#2a1419] border-white/10 text-rose-50" />
            </div>
            <div>
              <label className="text-sm">Rolle</label>
              <select 
                data-testid="register-role" 
                value={role} 
                onChange={(e)=>setRole(e.target.value)} 
                className="w-full p-2 rounded bg-[#2a1419] border border-white/10 text-rose-50"
              >
                <option value="fan">🎉 Fan - Kann Grüße senden & Kiosk sehen</option>
                <option value="sparring">🏀 Sparringspartner - Kann zu Trainings & abstimmen</option>
              </select>
              <p className="text-xs text-rose-200/60 mt-1">
                Spieler & Admin-Rollen werden von Admins vergeben
              </p>
            </div>
            <Button data-testid="register-submit" type="submit" disabled={loading} className="w-full bg-[#b40023] hover:bg-[#97001d]">{loading?"Erstellen…":"Konto erstellen"}</Button>
          </form>
          <p className="text-xs mt-4 text-rose-100/70">Schon ein Konto? <Link data-testid="go-login" className="underline" to="/login">Anmelden</Link></p>
        </CardContent>
      </Card>
    </div>
  );
}
